var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-screen',{attrs:{"title":_vm.$ml.get('errorPageTitle'),"text":_vm.text,"action":_vm.nextScreen,"button-text":_vm.$ml.get('errorPageButtonStartAgain'),"headerImg":3,"hideButton":this.callbackUrl.length === 0}})
}
var staticRenderFns = []

export { render, staticRenderFns }